import { render, staticRenderFns } from "./Payment2.vue?vue&type=template&id=02fc3de4&"
import script from "./Payment2.vue?vue&type=script&lang=js&"
export * from "./Payment2.vue?vue&type=script&lang=js&"
import style0 from "./Payment2.vue?vue&type=style&index=0&id=02fc3de4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports